import axios from "axios";

// Function to Refresh Token
export const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }
   
    const response = await axios.post(process.env.REACT_APP_BASE_URL+"/auth/token/refresh/", {
      refresh: refreshToken,
    });

    const newAccessToken = response.data.access;
    localStorage.setItem("authToken", newAccessToken); // Store new token

    return newAccessToken;
  } catch (error) {
   // alert("Error refreshing token: at authUTIL", error);
    alert("Session expired");
   
   console.error("Error refreshing token:", error);
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login"; // Redirect to login
    return null;
  }
};
